import React, { useState, useEffect } from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import NodataImage from '../../../../../images/nodata.png'
import {
    getWorkFlowStepsOrderedNew, deleteWorkflowStepsById, SaveWorkFlowSteps, UpdateWorkFlowSteps
} from '../ActionCreator'
import Loader from '../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../presentationals/Popup/Popup.component'
import ConfirmationPopup from "../../../../presentationals/Popup/ConfirmationPopup.component";
import { COMPANY_NAME } from '../../../../../utils/api-factory'
import Pagination from '@mui/material/Pagination';
import { formatDateNew } from '../../../../../utils/commonUtility';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import systemIcons1 from '../../../../../images/systemIcons1.png'
import systemplan1 from '../../../../../images/systemplan1.png'
import manual1 from '../../../../../images/manual1.png'
const itemsPerPage = 10;

export default function List() {
    const [loader, setLoader] = useState(false)
    const [popup, setpopup] = useState({ show: false, popupStatus: "" })
    const [searchValue, setSearchValue] = useState("")
    const [viewType, setviewType] = useState({ type: "", data: "" })
    const [apiData, setApiData] = useState({})
    const [filteredData, setFilteredData] = useState([]);
    const [datashow, setDatashow] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [paginatedData, setPaginatedData] = useState([]);
    const [showModal, setshowModal] = useState(false)
    const [deleteData, setDeleteData] = useState({})
    const [editPopup, setEditPopup] = useState({ show: false, type: "" })
 const [objectData, setObjectData] = useState({
        "stepName": "",
        "stepDescription": "",
        "stepOrder": "",
        "triggerType": "",
    })

    useEffect(() => {
        getWorkFlowStepsOrderedNewFn()
    }, [])

    const changeSearchValue = (e) => {
        setSearchValue(e.target.value)
    }

    const handleSearchbtn = (e) => {
        if (e.key === "Enter") {
            if (searchValue?.length > 0) {
                const lowerSearch = searchValue.toLowerCase();
                const newFilteredData = {};

                Object.entries(apiData).forEach(([triggerType, steps]) => {
                    const matchedSteps = steps.filter(step =>
                        step.stepName?.toLowerCase().includes(lowerSearch)
                    );

                    if (matchedSteps.length > 0) {
                        newFilteredData[triggerType] = matchedSteps;
                    }
                });

                const firstKey = Object.keys(newFilteredData)?.[0];
                setDatashow(firstKey);
                setFilteredData(newFilteredData?.[firstKey] || []);
                setCurrentPage(1);
                paginate(newFilteredData?.[firstKey] || [], 1);
            } else {
                // If search is empty, show current tab data
                const currentTabData = apiData?.[datashow] || [];
                setFilteredData(currentTabData);
                setCurrentPage(1);
                paginate(currentTabData, 1);
            }
        }
    }

    const handlePage = (type, data) => {
        setviewType({ type: type, data: data })
        if(type == "add" || type == "edit"){
            setObjectData({
                "stepName": data?.stepName ?? "",
                "stepDescription": data?.stepDescription ?? "",
                "stepOrder": data?.stepOrder ?? "",
                "triggerType": data?.triggerType ?? "",
            })
              setEditPopup({ show: true, type: type })
        }else{
             setEditPopup({ show: false, type: "" })
        }
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const paginate = (data, page) => {
        const startIndex = (page - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const sliced = data.slice(startIndex, endIndex);
        setPaginatedData(sliced);
    };

    const handleTabSelected = (type) => {
        setDatashow(type);
        const data = apiData?.[type] || [];
        setFilteredData(data);
        setCurrentPage(1);
        paginate(data, 1);
    }

    const handlePagePagination = (e, value) => {
        setCurrentPage(value);
        paginate(filteredData, value);
    };


    const handleDeleteclick = (data) => {
        setDeleteData(data)
        setshowModal(true)
    }

     const handleformchange = (e, type) => {
        setObjectData((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }


    const cancelLoanConfirm = (type) => {
        if (type == "yes") {
            setshowModal(false)
            handleDelete(deleteData?.stepId)
        } else if (type == "no") {
            setshowModal(false)
            setDeleteData({})
        }
    }


    const handleDelete = (id) => {
        setLoader(true)
        deleteWorkflowStepsById(id, callback => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.message == "success") {
                setpopup({ show: true, popupStatus: 'Data Deleted Successfully' })
                getWorkFlowStepsOrderedNewFn()
            } else {
                setpopup({ show: true, popupStatus: 'Error Deleting Successfully' })
            }
            removePopup()
        })
       

    }

    const getWorkFlowStepsOrderedNewFn = () => {
        setLoader(true)
        getWorkFlowStepsOrderedNew(callback => {
             setLoader(false)
            if (callback?.status == 200 && callback?.message == "success") {
                setApiData(callback?.data)

               
                const data = callback?.data;

                if (data?.MANUAL != null && Object.keys(data?.MANUAL)?.length > 0) {
                    setDatashow('MANUAL');
                    setFilteredData(data?.MANUAL);
                    paginate(data?.MANUAL, 1);
                } else {
                    const firstKey = Object.keys(data)?.[0];
                    setDatashow(firstKey);
                    setFilteredData(data?.[firstKey] || []);
                    paginate(data?.[firstKey] || [], 1);
                }
            } else {
                setApiData({})
                setFilteredData([]);
                setPaginatedData([]);
            }
        })
    }

    const handleSave = (type) => {
            const obj = { ...objectData }
            if (type == "add") {
                obj.companyName = COMPANY_NAME;
                setLoader(true)
                SaveWorkFlowSteps(obj, callback => {
                    setLoader(false)
                    if (callback && callback?.message == "success") {
                        setpopup({ show: true, popupStatus: 'Data Saved Successfully' })
                    } else {
                        setpopup({ show: true, popupStatus: 'Error Saving Data' })
                    }
                    getWorkFlowStepsOrderedNewFn()
                    removePopup()
                    handlePage("closePopup", "")
                })
            } else if (type == "edit") {
                obj.companyName = COMPANY_NAME;
                setLoader(true)
                UpdateWorkFlowSteps(viewType?.data?.stepId, obj, callback => {
                    setLoader(false)
                    if (callback && callback?.message == "success") {
                        setpopup({ show: true, popupStatus: 'Data Saved Successfully' })
                    } else {
                        setpopup({ show: true, popupStatus: 'Error Updating Data' })
                    }
                    getWorkFlowStepsOrderedNewFn()
                    removePopup()
                })
            }
        }

    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            {
                popup?.show ?
                    <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
                    : ""
            }

            {showModal ?
                <ConfirmationPopup cancelLoanConfirm={cancelLoanConfirm} confirmationText={'Are you sure you want to delete this template?'} />
                : ""}

            <div className="container-fluid" style={{ marginTop: '100px' }}>
                <div className="row">
                    <div className="col-lg-2 col-sm-3 col-xs-4">
                        <label htmlFor=""><i className="fa fa-search" aria-hidden="true"></i>&nbsp;Search</label>
                        <input className='form-control' placeholder='Search by Step Name' type='search' value={searchValue} onChange={(e) => changeSearchValue(e)} onKeyDown={(e) => handleSearchbtn(e)} />
                    </div>
                    <div className="col-sm-2 col-xs-12" style={{ float: 'right', textAlign: 'end' }}>
                        <button className='btn' onClick={() => handlePage('add', "")} style={{ padding: '10px 15px', borderRadius: '6px', background: 'grey', color: '#fff', marginTop: '22px' }}><i className="fa fa-plus-circle" aria-hidden="true"></i>&nbsp; Steps</button>
                    </div>
                </div>
                <hr />

                <div className="row">
                    <div className="col-sm-4 col-xs-12">
                        <div className='customCardscss'>
                            <div className='blueTheme'>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="Iconcontent">
                                        <img src={systemIcons1} width={"30px"} alt="System Icon" />
                                    </div>
                                    {/* Fixed: Use .length instead of Object.keys().length for arrays */}
                                    <h5 style={{ fontSize: '30px', fontWeight: '700', color: '#1d4ed8' }}>
                                        {apiData && Object.keys(apiData)?.length > 0 && apiData?.SYSTEM ? apiData?.SYSTEM?.length : 0}
                                    </h5>
                                </div>
                                <h3
                                    className={`cardsheadings ${datashow == "SYSTEM" ? "active" : ''}`}
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: '600',
                                        color: '#1e3a8a',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => handleTabSelected("SYSTEM")}
                                >
                                    System <ArrowRightIcon />
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4 col-xs-12">
                        <div className='customCardscss'>
                            <div className='greenTheme'>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="Iconcontent">
                                        <img src={systemplan1} width={"30px"} alt="System Plan Icon" />
                                    </div>
                                    {/* Fixed: Use .length instead of Object.keys().length for arrays */}
                                    <h5 style={{ fontSize: '30px', fontWeight: '700', color: '#22723d' }}>
                                        {apiData && Object.keys(apiData)?.length > 0 && apiData?.SYSTEM_PLAN ? apiData?.SYSTEM_PLAN?.length : 0}
                                    </h5>
                                </div>
                                <h3
                                    className={`cardsheadings ${datashow == "SYSTEM_PLAN" ? "active" : ''}`}
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: '600',
                                        color: '#22723d',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => handleTabSelected("SYSTEM_PLAN")}
                                >
                                    System Plan <ArrowRightIcon />
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4 col-xs-12">
                        <div className='customCardscss'>
                            <div className='purpleTheme'>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="Iconcontent">
                                        <img src={manual1} width={"30px"} alt="Manual Icon" />
                                    </div>
                                    {/* Fixed: Use .length instead of Object.keys().length for arrays */}
                                    <h5 style={{ fontSize: '30px', fontWeight: '700', color: '#653893' }}>
                                        {apiData && Object.keys(apiData)?.length > 0 && apiData?.MANUAL ? apiData?.MANUAL?.length : 0}
                                    </h5>
                                </div>
                                <h3
                                    className={`cardsheadings ${datashow == "MANUAL" ? "active" : ''}`}
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: '600',
                                        color: '#653893',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => handleTabSelected("MANUAL")}
                                >
                                    Manual <ArrowRightIcon />
                                </h3>
                            </div>
                        </div>
                    </div>

                    <div className="col-xs-12" style={{ marginTop: '25px' }}>
                        {
                            paginatedData && paginatedData?.length > 0 ?
                                <div className="" style={{ boxShadow: '3px 3px 10px 3px #eee', borderRadius: '0px', marginTop: '0' }}>
                                    <table className='phocket-table'>
                                        <thead>
                                            <tr>
                                                <th className='text-center'>Order</th>
                                                <th className='text-center'>Name</th>
                                                <th className='text-center'>Description</th>
                                                <th className='text-center'>Added On</th>
                                                <th className='text-center'>Edit</th>
                                                <th className='text-center'>Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ borderRadius: '0px' }}>
                                            {paginatedData && paginatedData?.length > 0 ? paginatedData?.map((data, i) => (
                                                <tr key={i} style={{ borderRadius: '0px' }}>
                                                    <td className='text-center' style={{ borderRadius: '0px', padding: '13px', border: '0px', borderBottom: '1px solid #eee' }}>{data.stepOrder}</td>
                                                    <td className='text-center' style={{ border: '0px', borderBottom: '1px solid #eee' }}>{data?.stepName}</td>
                                                    <td className='text-center' style={{ border: '0px', borderBottom: '1px solid #eee' }}>{data?.stepDescription}</td>
                                                    <td className='text-center' style={{ border: '0px', borderBottom: '1px solid #eee' }}>{formatDateNew(data?.creationDate)}</td>
                                                    <td className='text-center' style={{ border: '0px', borderBottom: '1px solid #eee' }}><i style={{ cursor: 'pointer' }} className="fa fa-edit" onClick={() => handlePage('edit', data)}></i></td>
                                                    <td className='text-center' style={{ borderRadius: '0px', border: '0px', borderBottom: '1px solid #eee' }}><i style={{ cursor: 'pointer' }} className="fa fa-trash" onClick={() => handleDeleteclick(data)}></i></td>
                                                </tr>
                                            )) : ""}
                                        </tbody>
                                    </table>
                                    <div style={{ float: "right", marginTop: '20px' }}>
                                        <Pagination
                                            count={Math.ceil(filteredData?.length / itemsPerPage)}
                                            page={currentPage}
                                            onChange={handlePagePagination}
                                            color="primary"
                                        />
                                    </div>
                                </div>
                                :
                                <p className='text-center' style={{ marginTop: '20px' }}><img src={NodataImage} width={"30%"} alt="No data" /></p>
                        }
                    </div>
                </div>



                {
                    editPopup?.show ?
                        <div className="background-blur">

                            <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', top: editPopup?.type == "edit" ? '2%' : "15%", width: '80%' }}>
                                <i onClick={() => handlePage("closePopup", "")} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>

                                <Accordion defaultExpanded >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                        style={{ borderBottom: '1px solid #ccc' }}
                                    >
                                        <Typography component="span">{editPopup?.type == "edit" ? "Edit" : "Add"} Steps</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div>
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-6 col-xs-12">
                                                    <label htmlFor="">Step Name</label>
                                                    <input type='text' className='form-control' value={objectData?.stepName} onChange={(e) => handleformchange(e, "stepName")} />
                                                </div>
                                                <div className="col-sm-6 col-xs-12">
                                                    <label htmlFor="">Step Description</label>
                                                    <input type='text' className='form-control' value={objectData?.stepDescription} onChange={(e) => handleformchange(e, "stepDescription")} />
                                                </div>
                                                <div className="col-sm-6 col-xs-12" style={{marginTop:'10px'}}>
                                                    <label htmlFor="">Step Order</label>
                                                    <input type='number' className='form-control' value={objectData?.stepOrder} onChange={(e) => handleformchange(e, "stepOrder")} />
                                                </div>
                                                <div className="col-sm-6 col-xs-12" style={{marginTop:'10px'}}>
                                                    <label htmlFor="">Trigger Type</label>
                                                   <select 
                                                   className='form-control' 
                                                   value={objectData?.triggerType}
                                                    onChange={(e) => handleformchange(e, "triggerType")}
                                                    disabled={editPopup?.type == "edit" ? true : false}
                                                   >
                                                    <option value={""}>Select</option>
                                                    <option value={"SYSTEM"}>System</option>
                                                    <option value={"MANUAL"}>Manual</option>
                                                    <option value={"SYSTEM_PLAN"}>System Plan</option>
                                                   </select>
                                                </div>
                                            </div>

                                            <div className="row" style={{ marginTop: '40px' }}>
                                                <div className="col-xs-12 text-center">
                                                    <button className='btn' onClick={() => handleSave(editPopup?.type)} style={{ padding: '10px 15px', borderRadius: '6px', background: '#1eb0d2', color: '#fff' }}>{editPopup?.type == "edit" ? "Update" : "Save"}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>


                            </div>
                        </div>
                        : ''
                }
            </div>
        </>
    )
}